import {
  ENABLER_CIRCLE_IDS,
  enablerCircleMaskSrc,
  enablerCirclePhotoSrc,
  type EnablerCircleId,
} from '@/constants/enablerCircles';

export type EnablerCircleTexture = {
  photoSrc: string;
  maskSrc: string;
};

/** Figma `192:163453` — 2× photo + per-circle SVG Union mask. */
export const enablerCircleTextures: Record<EnablerCircleId, EnablerCircleTexture> =
  Object.fromEntries(
    ENABLER_CIRCLE_IDS.map((id) => [
      id,
      {
        photoSrc: enablerCirclePhotoSrc(id),
        maskSrc: enablerCircleMaskSrc(id),
      },
    ]),
  ) as Record<EnablerCircleId, EnablerCircleTexture>;

export function getEnablerCircleTexture(id: string): EnablerCircleTexture | undefined {
  if ((ENABLER_CIRCLE_IDS as readonly string[]).includes(id)) {
    return enablerCircleTextures[id as EnablerCircleId];
  }
  return undefined;
}
